import { render, staticRenderFns } from "./campos.vue?vue&type=template&id=56aecac4&"
import script from "./campos.vue?vue&type=script&lang=js&"
export * from "./campos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports